import zhCN from './zh_CN'

export default {
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其他',
    closeAll: '关闭全部'
  },
  ...zhCN,
  ETD: 'ETD',
  ETA: 'ETA',
  i18nDemo: {
    message: '这是一个中文提示',
    btnDesc: '中文按钮',
    messageBtn: '点击我看消息'
  },
  baseInfo: {
    seaport: {
      tabPort: {
        tabName: '港口'
      },
      tabEdiPort: {
        tabName: 'EDI 港口',
        shipCompany: '船公司',
        originPortCode: '原港口代码',
        currentPortCode: '现港口代码',
        shipCompanyCheck: '请选择船公司!',
        originPortCodeCheck: '请选择港口!',
        currentPortCodeCheck: '请输入5位港口代码!'
      },
      tabAmsPort: {
        tabName: 'AMS 港口',
        amsPortMaintain: 'AMS港口维护',
        usNo: 'US NO',
        englishName: '英文名称',
        unNo: 'UN NO',
        country: '国家',
        remark: '备注',
        usNoCheck: '请录入正确的US NO.',
        englishNameCheck: '英文名称不能为空.',
        unNoCheck: '请录入正确的UN NO.',
        countryCheck: '国家不能为空.'
      }
    },
    city: {
      code: '代码',
      chineseName: '中文名',
      englishName: '英文名',
      locationCode: '城市编号',
      country: '国家',
      addBaseCity: '添加基础城市',
      codeCheck: '代码不能为空!',
      englishNameCheck: '英文名不能为空!',
      countryCheck: '请选择国家!',
      lon: '经度',
      lat: '纬度'
    },
    overseaWarehouse: {
      warehouseCode: '仓库编码',
      countryChineseName: '中文名',
      countryEnglishName: '英文名',
      country: '国家',
      province: '州',
      city: '城市',
      zipCode: '邮编',
      address: '详细地址',
      address1: '地址一',
      address2: '地址二',
      address3: '地址三',
      ifFba: '是否亚马逊仓',
      entryRequirements: '进仓要求',
      warehouseAgeCalculationRules: '库龄计算规则',
      warehouseAgeCalculationRulesEdit: '库龄计算规则(周)',
      btn: {
        newFbaWarehouse: '新增亚马逊仓',
        newOverseaWarehouse: '新增海外仓'
      },
      msg: {
        warehouseNoEmpty: '仓库编码不能为空',
        countryNoEmpty: '国家不能为空',
        cityNoEmpty: '城市不能为空',
        zipCodeNoEmpty: '邮编不能为空',
        addressNoEmpty: '详细地址不能为空',
        chineseNameNoEmpty: '中文名不能为空',
        englishNameNoEmpty: '英文名不能为空',
        warehouseAgeCalculationRulesNoEmpty: '库龄计算规则不能为空',
        unSelectFbaWarehouse: 'FBA仓未选择',
        canNotEditFbaWarehouse: '不能编辑亚马逊仓',
        duplicateAddition: '{0} 已添加，不能重复添加',
        warehouseNoLen: '海外仓仓库编码长度不能超过16位'
      }
    },
    basicData: {
      continent: {
        code: '代码',
        name: '名字',
        codeCheck: '代码不能为空!',
        nameCheck: '名字不能为空!'
      },
      region: {
        code: '代码',
        name: '中文名',
        nameEnglish: '英文名',
        codeCheck: '代码不能为空!',
        nameCheck: '中文名不能为空!'
      },
      mscService: {
        serviceCode: '服务代码',
        serviceName: '服务名称',
        serviceCodeCheck: '服务代码不能为空!',
        serviceNameCheck: '服务名称不能为空!'
      },
      network: {
        code: '网络代码',
        name: '网络名',
        codeCheck: '网络代码不能为空!',
        nameCheck: '网络名不能为空!'
      },
      currency: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        localName: '本地化名称',
        interchangeCode: '交换码',
        isoCode: 'ISO代码',
        defaultFractionDigits: '币种小数位数',
        symbol: '符号',
        remarks: '备注',
        addBaseCurrency: '添加基础币种',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO代码不能为空!',
        defaultFractionDigitsCheck: '币种小数位数不能为空!',
        carryRule: '币种进位规则',
        rounding: '四舍五入',
        truncation: '舍位'
      },
      eqType: {
        code: '代码',
        name: '名称',
        localName: '本地化名称',
        remark: '备注',
        addBaseEQType: '添加基础箱型',
        codeCheck: '代码不能为空!'
      },
      packing: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        englishName: '英文名称',
        chineseName: '中文名称',
        interchangeCode: '交换码',
        isoCode: 'ISO代码',
        position: '位置',
        ediCode: 'EDI编码',
        addBasePacking: '添加基础包装',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO代码不能为空!',
        positionCheck: '位置不能为空!',
        userDefinedField: '自定义字段'
      },
      orderFormType: {
        code: '代码',
        name: '名称',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!'
      },
      cargoType: {
        code: '代码',
        chineseName: '中文名称',
        englishName: '英文名称',
        sea: '海运使用',
        air: '空运使用',
        fbaSea: 'FBA海运使用',
        fbaAir: 'FBA空运使用',
        fbaRailway: 'FBA铁路使用',
        codeCheck: '代码不能为空!',
        chineseNameCheck: '中文名称不能为空!'
      },
      incoTerm: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        localName: '本地化名称',
        interchangeCode: '交换码',
        isoCode: 'ISO码',
        remark: '备注',
        addBaseIncoTerm: '添加基础贸易条款',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO码不能为空!'
      },
      shippingTerm: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        localName: '本地化名称',
        interchangeCode: '交换码',
        isoCode: 'ISO码',
        remark: '备注',
        addBaseShippingTerm: '添加基础运输条款',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO码不能为空!',
        defaultContainerLoadType: '整拼类型默认显示',
        defaultShow: '默认显示',
        operationTypeTip: '※配置后新增海运进出口业务对应整拼类型的主单/分单运输条款栏，默认显示该运输条款'
      },
      paymentTerm: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        localName: '本地化名称',
        interchangeCode: '交换码',
        isoCode: 'ISO码',
        remark: '备注',
        addBasePaymentTerm: '添加基础运费条款',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO码不能为空!'
      },
      tradeTerm: {
        serialNumber: '序号',
        code: '代码',
        name: '中文名称',
        localName: '本地化名称',
        englishName: '英文名称',
        interchangeCode: '交换码',
        isoCode: 'ISO码',
        remark: '备注',
        addBaseTradeTerm: '添加基础贸易方式',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO码不能为空!'
      },
      priceAirService: {
        code: '代码',
        chineseName: '中文名称',
        englishName: '英文名称',
        codeCheck: '代码不能为空!',
        chineseNameCheck: '中文名称不能为空!'
      },
      portGroup: {
        portCode: '港口代码',
        groupCode: '港口群',
        portCodeCheck: '港口代码不能为空!',
        groupCodeCheck: '港口群不能为空!'
      },
      otherChargeItem: {
        chargeItemCode: '代码',
        chineseName: '中文名称',
        measure: '计费方式',
        defaultApPrice: '默认应收单价',
        remark: '备注',
        chargeWeight: '按计费重量计算',
        wt: '按毛重计算',
        job: '按票数计算',
        chargeItemCodeCheck: '代码不能为空!',
        chineseNameCheck: '中文名称不能为空!'
      },
      customerType: {
        typeId: '级别',
        chineseName: '中文名称',
        englishName: '英文名称',
        typeIdCheck: '级别不能为空!',
        chineseNameCheck: '中文名称不能为空!',
        englishNameCheck: '英文名称不能为空!'
      },
      appraisalCategory: {
        serialNumber: '序号',
        serialNumberCheck: '序号不能为空',
        code: '代码',
        codeCheck: '代码不能为空',
        chineseName: '中文名称',
        englishName: '英文名称',
        chineseNameCheck: '中文名称不能为空!',
        englishNameCheck: '英文名称不能为空!'
      },
      blMode: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        localName: '本地化名称',
        interchangeCode: '交换码',
        isoCode: 'ISO码',
        blType: '提单类型',
        remark: '备注',
        addBaseBlMode: '添加提单方式',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        interchangeCodeCheck: '交换码不能为空!',
        isoCodeCheck: 'ISO码不能为空!'
      },
      cutomJobType: {
        serialNumber: '序号',
        code: '代码',
        name: '名称',
        localName: '本地名称',
        englishName: '英文名称',
        type: '业务类型',
        remarks: '备注',
        containerLoadType: '业务模式',
        addBaseBlMode: '添加基础贸易方式',
        serialNumberCheck: '序号不能为空!',
        codeCheck: '代码不能为空!',
        nameCheck: '名称不能为空!',
        englishNameCheck: '英文名称不能为空!',
        typeCheck: '业务类型不能为空!',
        interchangeCode: '交换代码',
        codeTips1: '*代码格式为：英文和数字，字数限制为4位。',
        codeTips2: '代码长度超限，请重新输入！',
        codeTips3: '代码格式不正确，请重新输入！',
        codeTips4: '*代码格式为：英文、数字及组合，字数限制为10位。'
      },
      chargeUnit: {
        codeCheck: '代码不能为空!',
        chineseNameCheck: '中文名称不能为空!',
        englishNameCheck: '英文名称不能为空!',
        chargeUnitAndUnitCheck: '计费单位和单位至少勾选一个显示，请选择！',
        seaFreightAndAirFreightCheck: '海运和空运至少勾选一个显示，请选择！',
        businessTypeCheck: '海运、空运、FBA海运、FBA空运、FBA铁路至少勾选一个显示，请选择！',
        fbaSeaAndAirAndRailwayCheck: '海运空运以及铁路至少勾选一个显示，请选择！'
      },
      dangerousGoods: {
        codeCheck: '请填写联合国编号'
      },
      cargoInformation: {
        codeCheck: '代码不能为空!',
        chineseNameCheck: '中文名称不能为空!',
        englishNameCheck: '英文名称不能为空!'
      },
      propulsionType: {
        codeCheck: '名称不能为空!'
      },
      baseCustomsDeclarationType: {
        code: '代码',
        name: '中文名',
        englishName: '英文名',
        codeCheck: '代码不能为空!',
        nameCheck: '中文名不能为空!',
        englishNameCheck: '英文名不能为空!',
        codeTooLong: '列【代码】数据太长',
        nameTooLong: '列【中文名】数据太长',
        englishNameTooLong: '列【英文名】数据太长',
        addBaseCustomsDeclarationType: '新增报关类型',
        isPlatform: '是否平台数据',
        PlatformTip: '平台新增数据不能修改！'
      },
      gpExplainTitle: {
        codeCheck: '代码不能为空!',
        chineseNameCheck: '中文名称不能为空!',
        englishNameCheck: '英文名称不能为空!'
      }
    },
    airport: {
      addBasePort: '添加基础港口',
      serialNumber: '序号',
      code: '代码',
      chineseName: '中文名',
      englishName: '英文名',
      interchangeCode: '交换码',
      isoCode: 'ISO代码',
      countryCode: '国家',
      region: '区域',
      requirement: '港口要求',
      whetherToAdd: '是否已添加',
      portAdd: '港口新增',
      portEdit: '港口编辑',
      cityName: '城市名称',
      cityCode: '城市代码',
      codeCheck: '请填写正确的港口代码',
      interchangeCodeCheck: '交换码不能为空',
      isoCodeCheck: 'ISO码不能为空',
      englishNameCheck: '英文名不能为空'
    },
    operation: {
      operationType: '操作要求类型',
      lobType: '业务类型',
      code: '代码',
      lob: '业务类型',
      operationRequirementType: '操作类型',
      contentDescription: '代码/内容描述',
      operationMaintain: '操作要求维护',
      remark: '备注',
      enterContentDescription: '请输入代码或内容描述'
    },
    customsCommodityCode: {
      code: '商品编码',
      commodityName: '品名',
      mfnRate: '最惠国税率',
      generalRate: '普通税率',
      vat: '增值税',
      legalUnit: '法定单位',
      mscCommodity: '英文品名(MSC)',
      secondUnit: '第二单位',
      superviseMode: '监管方式',
      customsCommodityCodeMaintain: '海关商品编号维护',
      countryCode: '国家编码',
      countryCodeCheck: '国家代码不能为空. ',
      codeCheck: '商品编码不能为空. ',
      commodityNameCheck: '品名不能为空.'
    },
    usCommodityCode: {
      systemCode: '系统代码',
      tradeName: '商品名称',
      productDescription: '商品说明',
      descriptionCode: '说明代码',
      customsTariff: '海关税率',
      additionalTaxRate056: '056附加税率',
      including499AdditionalTaxRate: '含499附加税率',
      including501AdditionalTaxRate: '含501附加税率',
      chinaAdditionalTaxRate: '中国附加税率',
      chinaSurtaxTariff: '中国附加税税则',
      chinaSurtaxClause: '中国附加税条款',
      enable: '启用',
      disable: '禁用',
      chinaHongKongSurtaxTariff: '中国香港附加税税则',
      remark: '备注'
    },
    country: {
      serialNumber: '序号',
      code: '代码',
      englishName: '英文名',
      chineseName: '中文名',
      continent: '大洲',
      interchangeCode: '交换码',
      isoCode: 'ISO代码',
      countryMaintain: '国家维护'
    },
    rateManagement: {
      copyRate: '复制汇率',
      originalCurrency: '原货币',
      benchmarkCurrency: '基准货币',
      rate: '汇率',
      effectiveMonth: '有效月份',
      currentMonth: '当前月份',
      baseCuurency: '基准货币',
      currency: '原货币',
      month: '有效月份',
      rateMaintain: '汇率维护',
      currencyCheck: '请输入原货币!',
      rateCheck: '请输入汇率!',
      rateIsTooLong: '汇率太大，请修改',
      repeatCheck: '出现重复配置，请修改!',
      repeatCheck2: '{0}转{1}汇率出现重复配置，请修改!',
      copyRateMaintain: '复制指定月份的汇率',
      copyCurrentMonthCheck: '不能复制当前月份的数据，请选择其它的月份!',
      copyRowDataCheck: '没有此月份的数据!',
      copyRateSuccess: '复制汇率成功',
      notFoundRate: '找不到币种{0}的汇率,请及时维护相关汇率！',
      setRateCacheRange: '设置汇率缓存时长',
      setRateCacheRangeNote: '设置汇率缓存的月份范围为18-36个月',
      setRateCacheRangePrefix: '缓存月份',
      setRateCacheRangeSuffix: '个月'
    },
    // 合作伙伴
    partner: {
      companyName: '合作伙伴',
      companyType: '客户类型',
      customerTypeId: '客户级别',
      remarks: '附加说明',
      approvedState: '审核状态',
      volume: '票数',
      cmpIdx: '编号',
      shortName: '简称',
      cnShortName: '代码',
      region: '国家',
      area: '地区',
      chineseName: '中文名称',
      englishName: '英文名称',
      contractStatus: '签约状态',
      branchId: '所属分公司',
      approvedBy: '审核人',
      dateApproved: '审核日期',
      createBy: '创建人',
      dateType: '日期类型',
      controlSetting: '信控设置日期类型',
      creditDateType: '结算方式',
      blacklist: '黑名单',
      cargoSource: '揽货类型',
      receivableDeposit: '收支类型',
      accountingPeriod: '账期',
      quota: '额度',
      creditQuota: '信控额度',
      creditCurrency: '信控币种',
      payment: '付款',
      supplierDirector: '供应商负责人',
      dateCreated: '创建日期',
      modifiedBy: '修改人',
      dateModified: '修改日期',
      isActive: '是否有效',
      relateTenantUuid: '电商客户',
      sales: '销售',
      freightVolume30: '30天(票)',
      freightVolume60: '60天(票)',
      freightVolume90: '90天(票)',
      freightVolumeGt90: '大于90天(票)',
      // 基础信息
      basicInfo: {
        title: '基础信息',
        relatedBusinessType: '相关业务类型',
        scac: 'SCAC',
        province: '省',
        city: '市',
        district: '区'
      }
    },
    // 收发通地址
    mailingAddress: {
      office: '分公司',
      lobType: '业务类型',
      partner: '客户/海外代理',
      podName: '目的港名称',
      shipperCode: '发货人代码',
      shipperInfo: '发货人信息',
      consigneeCode: '收货人代码',
      consigneeInfo: '收货人信息',
      notifyCode: '通知人代码',
      notifyInfo: '通知人信息',
      shipperName: '发货人名称',
      consigneeName: '收货人名称',
      notifyName: '通知人名称',
      partner1: '客户',
      pod1: '目的港',
      formatManifestInfo: '格式化舱单信息',
      shipper: '发货人',
      shipperEnterpriseCode: '发货人企业代码',
      shortCode: '代码缩写',
      enterpriseCode: '企业代码',
      shipperEnterpriseName: '发货人企业名称',
      shipperAddress: '发货人详细地址',
      cityName: '城市名称',
      provinceCode: '省份代码',
      provinceName: '省份名称',
      zipCode: '邮政编码',
      countryCode: '国家代码',
      aeoEnterpriseCode: 'AEO企业编号',
      syncFormatInfoToOrder: '同步格式化信息至订单',
      consignee: '收货人',
      instructBill: '指示提单',
      consigneeEnterpriseCode: '收货人企业代码',
      consigneeEnterpriseName: '收货人企业名称',
      consigneeAddress: '收货人详细地址',
      consigneeSpecificContactsName: '具体联系人名称',
      consigneeSpecificContacts: '具体联系人电话',
      notify: '通知人',
      notifyEnterpriseCode: '通知人企业代码',
      notifyEnterpriseName: '通知人企业名称',
      notifyAddress: '通知人详细地址',
      shipperPhoneNumber: '发货人电话号码',
      shipperEmail: '发货人Email地址',
      shipperFax: '发货人电传号码',
      consigneePhoneNumber: '收货人电话号码',
      consigneeEmail: '收货人Email地址',
      consigneeFax: '收货人电传号码',
      consigneeSpecificPhoneNumber: '具体联系人电话号码',
      consigneeSpecificEmail: '具体联系人Email地址',
      consigneeSpecificFax: '具体联系人电传号码',
      notifyPhoneNumber: '通知人电话号码',
      notifyEmail: '通知人Email地址',
      notifyFax: '通知人电传号码',
      addMailingAddress: '新增收发通地址',
      editMailingAddress: '修改收发通地址',
      validLobMsg: '请选择业务代码.',
      validInstructBill: '收货人指定提单模式下, 通知人企业代码和通知人联系方式都必填.',
      fbaWarehouseCode: '亚马逊仓库编码',
      contactName: '联系人姓名',
      province: '省/州',
      addr1: '地址一',
      addr2: '地址二',
      addr3: '地址三',
      eoriNo: 'EORI/企业号',
      taxNo: '税号',
      ManifestFormatShipper: '舱单格式化发货人',
      TheManifestFormatConsignee: '舱单格式化收货人',
      ManifestFormatNotifier: '舱单格式化通知人'
    }
  },
  sysManage: { // 系统管理
    baseConfig: { // 基本配置
      triggerTypeManagement: { // 触发类型管理
        addTriggerType: '新增触发类型',
        editTriggerType: '编辑触发类型',
        lookTriggerType: '查看触发类型',
        validFieldNameMsg: '请输入字段名称.',
        validFieldEnameMsg: '请输入字段英文名称.',
        triggerType: '更新类型',
        fieldCheckType: '字段校验方式',
        entityCode: '实体代码',
        entityName: '实体名称',
        entityEname: '实体英文名称',
        fieldCode: '字段代码',
        fieldName: '字段名称',
        fieldEname: '字段英文名称',
        fieldCheckValue: '字段校验值',
        innerDateState: '状态来源于内部数据',
        outerDateState: '状态来源于外部数据',
        applySopNode: '应用SOP节点',
        remark: '备注'
      },
      routeWareHouseConfiguration: { // 航线与仓库配置
        addRouteWareHouseMapping: '新增航线与仓库配置',
        editRouteWareHouseMapping: '编辑航线与仓库配置',
        validRegionCodeMsg: '请输入航线代码.',
        validWarehouseMsg: '请选择仓库.',
        regionCode: '航线代码',
        warehouse: '仓库',
        remark: '备注'
      },
      singleOnlineSetting: { // 海运在线对单设置
        branchId: '分公司',
        fieldCode: '字段代码',
        fieldName: '字段名称',
        fclEdit: '允许编辑（整箱）',
        lclEdit: '允许编辑（拼箱）'
      }
    }
  },
  sysMonitor: { // 系统监控
    sopSendLog: {
      orderNo: '流水号',
      relationId: '业务编号',
      dateCreated: '推送时间',
      type: '类型',
      pushNode: '推送节点',
      pushingChannel: '推送渠道',
      pushingResult: '推送结果',
      receivingUser: '接收人',
      receivingTxt: '内容描述',
      modifyDate: 'sop变更时间',
      file: '文件'
    }
  },
  common: {
    defaultPlaceholder: '请输入关键词',
    BeginDate: '开始日期',
    EndDate: '截止日期',
    pagePer: '条/页',
    pleaseChoose: '请选择',
    confirm: '确认',
    reset: '重置',
    cancel: '取消',
    tips: {
      fuzzySearch: '请输入代码、名称等模糊查询',
      fuzzyCodeSearch: '请输入代码模糊查询',
      fuzzyModelSearch: '请输入机型模糊查询',
      overseaWarehouseFuzzySearch: '请输入海外仓代码模糊查询',
      fuzzySearchForJudgment: '请输入序号、判责原因模糊查询',
      fuzzySearchForCustomEqType: '请输入尺寸、箱种模糊查询',
      hasOneAtleast: '请至少选择一条记录',
      hasOneAtleastAudit: '请至少选择一条已审核记录',
      hasOneOnly: '请只选择一条记录',
      cannotDeleteBranch: '无法删除费用方案创建分公司！',
      saveSuccess: '保存成功!',
      prompt: '提示',
      systemPrompt: '系统提示',
      confirmDelete: '确认删除该条记录吗？',
      confirmCheck: '确认复核记录吗？',
      confirmCancelCheck: '确认取消复核记录吗？',
      confirm: '确认',
      deleteSuccess: '删除成功!',
      editSuccess: '编辑成功!',
      deleteFail: '删除失败!',
      cancelDelete: '取消删除!',
      yes: '是',
      no: '否',
      repeatedlyTip: '重复添加',
      pleaseChoose: '请选择',
      isAdded: '是否已添加',
      resetSuccess: '重置成功!',
      warning: '警告',
      branchSame: '正操作的数据所在分公司不属于当前分公司或上一级分公司！'
    },
    btn: {
      refresh: '刷新',
      query: '查询',
      look: '查看',
      new: '新增',
      add: '添加',
      edit: '编辑',
      editAgain: '重新编辑',
      delete: '删除',
      exportExcel: '导出Excel',
      downLoadTemplate: '下载模板',
      save: '保存',
      cancel: '取消',
      ok: '确定',
      confirm: '确认',
      back: '返回',
      audit: '审核',
      reject: '拒绝',
      reset: '重置',
      close: '关闭',
      yes: '是',
      no: '否',
      next: '下一步',
      confirmUpdate: '确认修改',
      enable: '启用',
      disable: '禁用'
    },
    createBy: '创建人',
    dateCreated: '创建时间',
    modifiedBy: '更改人',
    dateModified: '更改时间'
  },
  // 常量
  constant: {
    all: '全部',
    yes: '是',
    no: '否',
    greaterThan: '大于',
    lessThan: '小于',
    equal: '等于',
    email: '邮件',
    note: '短信',
    enterpriseWechat: '企业微信',
    sop: { // sop 常量

      JOB_NO: '业务编号',
      CUSTOMER_ID: '委托单位',
      CUSTOMER_ID_CN: '委托单位(中文)',
      CUSTOMER_ID_US: '委托单位(英文)',
      CARRIER_CN: '船公司(中文)',
      CARRIER_US: '船公司(英文)',
      CARRIER_CODE: '船公司(代码)',
      CARRIER_SHORT_NAME: '船公司(简称)',
      DESTINATION_AGENT: '目的港代理',
      DESTINATION_AGENT_SHORT_NAME: '目的港代理(简称)',
      DESIGNATION_AGENT: '指定货代理',
      BARGE_POL: '驳船起运港',
      LOADING_PORT_CODE: '起运港',
      LOADING_PORT_CODE3: '起运港代码',
      DESTINATION_PORT_CODE: '目的港',
      DESTINATION_PORT_CODE2: '目的港代码',
      VESSEL: '船名',
      VOYAGE: '航次',
      BRANCH_VESSEL: '支线驳船船名',
      BRANCH_VOYAGE: '支线驳船航次',
      WAREHOUSE_NO: '进仓编号',
      SO_NO: 'S/O NO.',
      MBL: 'MB/L NO',
      HBL_NO: 'HB/L NO',
      ETD: 'ETD',
      ETA: 'ETA',
      ATD: 'ATD',
      ATA: 'ATA',
      CUSTOMS_DATE: '操作日期',
      CONSIGNEE_CODE: '收货人',
      CUSTOMER_REF_NO: '业务参考号',
      USER_DEFINED_FIELD1: '自定义字段1',
      USER_DEFINED_FIELD2: '自定义字段2',
      USER_DEFINED_FIELD3: '自定义字段3',
      USER_DEFINED_FIELD4: '自定义字段4',
      ESTIMATED_SHIPPING_DATE: '预计船期',
      CSR: '客服',
      CSR_PHONE: '客服电话',
      CSR_EMAIL: '客服邮箱',
      OVERSEA_OP_EMAIL: '海外客服邮箱',
      DC_EMAIL: '单证邮箱',
      PORT_DISTRICT: '港区',
      TERMINAL_OPENDATE: '开港日期',
      TERMINAL_CUTOFF: '截港日期',
      REAL_ARRIVALS_DATE: '实际进港日期',
      BERTH_PLAN_DATE: '计划靠泊日期',
      ACTUAL_BERTH_PLAN_DATE: '实际靠泊日期',
      UN_BERTH_PLAN_DATE: '计划离泊日期',
      ACTUAL_UN_BERTH_PLAN_DATE: '实际离泊日期',
      BERTH_PLAN_PLACE: '计划靠泊泊位',
      ACTUAL_BERTH_PLAN_PLACE: '实际靠泊泊位',
      OP_EMAIL: '操作邮箱',
      DESTINATION_AGENT_EMAIL: '目的港代理默认联系人邮箱',
      SINGLE_ADDRESS: '对单地址',
      CUTOFF_TIME: '截单日期',
      EstimatedArrivalTime: '预计到港时间',
      actualArrivalTime: '实际到港时间',
      PortDischargeTime: '卸船时间',
      ActualLiftingDate: '实际提重时间',
      ActualReturnTime: '实际还空时间',
      MBLTransportationClause: '主单运输条款',
      HBLTransportationClause: '分单运输条款',
      MasterBLFreightTerm: '主单运费条款',
      HBLFreightClause: '分单运费条款',
      MORE_DOOR_QUANTITY: '多门点件数',
      ROUGH_WEIGHT: '多门点毛重',
      MORE_DOOR_VOLUME: '多门点体积',
      PACKAGING_TYPE: '包装类型',
      SHIPPER_CODE: 'HBL Shipper Code',
      BUSINESS_MODEL: '业务模式',
      TICKET_RECEIPT: '主票小票',
      NO_LISTING: '门点箱号清单',
      ESTIMATED_DELIVERY_DATE: '门点预计送货日期',
      UNLOADING_WAY: '门点卸货方式',
      PO: 'PO',
      CNEE_CODE: 'HBL CNEE Code',
      ADDRESS: '门点地址',
      BASIC_NUMBER: '基本页签-件数',
      BASIC_ROUGH_WEIGHT: '基本页签-毛重',
      BASIC_VOLUME: '基本页签-体积',
      DELIVER_DATE: '提货日期',
      ARRIVE_STORAGE_DATE: '到库日期',
      TRANS_DATE: '换单日期',
      CUSTOMER_REF_NO2: '客户参考号',
      LOADING_PORT_CODE2: '装货港',
      CARRIER_ID: '航空公司',
      CARRIER_ID_CN: '航空公司(中文)',
      CARRIER_ID_US: '航空公司(英文)',
      VOYAGE_FLIGHT: '航班',
      ETD2: '开航日期',
      ETA2: '到港日期',
      WAREHOUSE_NO2: '进仓编号',
      QUANTITY: '件数(入仓)',
      WEIGHT: '毛重(入仓)',
      VOLUME: '体积(入仓)',
      TRANSPORTATION_COMPANY: '运输公司',
      CONTAINER_NO: '箱号',
      SEAL_NO: '封号',
      EMPTY_CABINET_WEIGHT: '空柜重量',
      ESTIMATED_DATE: '预计装装箱(到厂)日期',
      ACTUAL_PACKING: '实际装箱(到厂)',
      CONTAINER_DESC: '箱量描述',
      EXPECTED_ARRIVAL_DATE: '预计到货日期',
      ACTUAL_ARRIVAL_DATE: '实际到货日期',
      CUSTOMER_DOOR_POINT: '客户门点',
      CUSTOMER_PORTAL_ADDRESS: '客户门点',
      DESTINATION_GATE_POINT: '目的地门点',
      ADDRESS_OF_DESTINATION_GATE_POINT: '目的地门点地址',
      WAREHOUSE_SUPPLIER: '仓库供应商',
      WAREHOUSE_NAME: '仓库名称',
      DOWNLOAD_URL: '预录单下载链接',
      MBL2: 'MAWB NO',
      HAWB: 'HAWB NO',
      DISCHARGING_PORT: '卸货港',
      DISCHARGING_PORT2: '卸货港代码',
      WAREHOUSE_DATA: '进仓数据',
      STATUS_UPDATE_TIME: '状态变更时间',
      QUANTITY_CONTRACT: '委托件数',
      WEIGHT_CONTRACT: '委托毛重',
      CUBAGE_CONTRACT: '委托体积',
      TRUST_FROM_JOB: '委托关联号',
      RELATED_JOB: '往来关联号',
      BASIC_SHIPPER_CODE: '基本发货人CODE',
      BASIC_CONSIGNEE_CODE: '基本收货人CODE',
      INCOTERMS: '贸易条款',
      CHARGE_WEIGHT: '计费重量',
      PACKAGE: '包装',
      REMARK: '备注',
      POD: '交货地',
      LOADING_PORT_CODE4: '装货港代码',

      MBLNO: '主票号码',
      CONTACT: '联系人',
      AIR_LINE: '航线',
      TRANSPORT_TYPE: '运输类型',
      DEPARTURE_STATION: '始发站',
      DEPARTURE_STATION_CODE: '始发站代码',
      DESTINATION_STATION: '目的站',
      DESTINATION_STATION_CODE: '目的站代码',
      TRANSIT_STATION: '过境站',
      TRANSIT_STATION_CODE: '过境站代码',
      PAYMENT_METHOD: '付款方式',
      TRACK_NO: '运单号',
      SHUTTLE: '班车',
      TRAIN_NO: '车次',
      QUANTITY_ACTUAL: '实际件数',
      WEIGHT_ACTUAL: '实际毛重',
      CUBAGE_ACTUAL: '实际体积',
      CARGO_CHINESE_NAME_BASE: '中文品名(基本)',
      CARGO_ENGLISH_NAME_BASE: '英文品名(基本)',
      CARGO_ENGLISH_NAME: '英文品名',
      SALES: '销售',
      SALES_EMAIL: '销售邮箱',
      // 新增毛体重
      ACTUAL_PIECE: '件数(实际)',
      ACTUAL_WEIGHT: '毛重(实际)',
      ACTUAL_VOLUME: '体积(实际)',
      CUSTOMER_SERVICE: '客服',
      DOCUMENT: '单证',
      ROUTE_MANAGER: '航线负责人',
      OVERSEAS_CUSTOMER_SERVICE: '海外客服',
      ROUTE_MANAGER_EMAIL: '航线负责人邮箱',
      INTEGRATION_TYPE: '整拼类型',
      ROUTE_LEADER: '路线负责人',
      ROUTE_LEADER_EMAIL: '路线负责人邮箱',
      OPERATE: '操作',
      MBLCMR: '主单号',
      DISCHARGING_PLACE: '发货地',
      LOADING_PORT: '起运地',
      DESTINATION_PORT: '目的地',
      DOMESTIC_PLATE_NUMBER: '国内车牌号',
      KH_PLATE_NUMBER: '卡航车牌',
      KH_TRAILER_NUMBER: '卡航挂车号',
      VOYAGE_FLIGHT_NO: '航班号',
      BOOKING_DATE: '订舱日期',
      ACTUAL_ENTRY_TIME: '实际进场时间',
      ACTUAL_LOADING_TIME: '实际配载时间',
      ESTIMATED_DEPARTURE_TIME: '预计起飞时间',
      ACTUAL_DEPARTURE_TIME: '实际起飞时间',
      ESTIMATED_ARRIVAL_TIME: '预计抵达时间',
      ACTUAL_ARRIVAL_TIME: '实际抵达时间',
      ACTUAL_RECEIVING_TIME: '实际收单时间',
      ACTUAL_UNLOADING_TIME: '实际卸货时间',
      ACTUAL_ARRIVAL_NOTIFICATION_TIME: '实际到货通知时间',
      ACTUAL_PICKUP_TIME: '实际提货时间',
      SECOND_FLIGHT: '航班号(二程信息)',
      ESTIMATED_TRANSFER_ARRIVAL_TIME: '预计抵达中转时间(二程信息)',
      TRANSFER_ARRIVAL_TIME: '抵达中转时间(二程信息)',
      ESTIMATED_TRANSFER_DEPARTURE_TIME: '预计中转起飞时间(二程信息)',
      TRANSFER_DEPARTURE_TIME: '中转起飞时间(二程信息)',
      Warehouse_Address: '仓库地址',
      Actual_Ship_Date: '实际发运日期(ATD)',
      Customs_Brokers: '报关行',
      Actual_Arrival_Date: '实际到达日期(ATA)',
      Actual_Packing_Date: '实际装箱日期',
      Door_Point: '门点',
      Additional_Notes: '附加说明',
      Estimated_Delivery_Time: '预计送货时间',
      Actual_Delivery_Time: '实际送货时间',
      PACKING: '包装',
      PACKING_CN: '包装(中文)',
      PACKING_US: '包装(英文)',
      TYPE_OF_GOODS: '货物类型',
      TYPE_OF_GOODS_CODE: '货物类型(代码)',
      MAIN_PAYMENT_LOCATION: '主单付款地点',
      MARK: '唛头',
      HS_NUMBER: 'HS编号',
      CUSTOM_POSITION_1: '自定义岗位1',
      CUSTOM_POSITION_2: '自定义岗位2',
      TRANSIT_PORT: '中转港',
      BOOKING_NUMBER: '订舱编号',
      SHIPPING_NUMBER: '船公司约号',
      BARGES_REMARKS: '支线驳船信息备注',
      MBL_SHIPPER: 'MB/L发货人',
      MBL_CONSIGNEE: 'MB/L收货人',
      MBL_NOTIFIER: 'MB/L通知人'
    },
    nodeType: {
      lodingPort: '起运港',
      transferPort: '中转港',
      destinationPort: '目的港',
      warehousing: '仓储',
      booking: '订舱',
      entrust: '委托',
      container: '做箱',
      distribution: '配送',
      supplement: '补充'
    },
    // 推送渠道
    pushingChannel: {
      all: '全部',
      email: '邮件',
      msg: '短信'
    },
    // sop类型
    sopTypes: {
      all: '全部',
      sopSend: 'sop推送',
      innerSend: '内部推送'
    },
    // 推送结果
    pushResult: {
      all: '全部',
      success: '成功',
      fail: '失败'
    },
    // 系统常量
    systemConstants: {
      SE: '海运出口',
      SI: '海运进口',
      AE: '空运出口',
      AI: '空运进口',
      RE: '铁路出口',
      RI: '铁路进口',
      RB: '铁路业务',
      IE: '综合物流',
      FBASE: 'FBA海运',
      FBAAE: 'FBA空运',
      FBARE: 'FBA铁路'
    },
    // 提单流水号类型
    BillType: {
      MBL: '主单',
      HBL: '分单'
    },
    // 进口业务常量
    importConstants: {
      FCL: '整箱',
      LCL: '拼箱',
      CON: '集拼',
      POJ: '项目',
      PVE: '私人物品',
      ECL: '委托拼箱',
      BULK: '散杂货',
      CONSOLE: '一主多分',
      DIRECT: '直单',
      BACK_TO_BACK: '一主一分'
    },
    // 空运出口常量
    airExportConstants: {
      CONSOLE: '一主多分',
      DIRECT: '直单',
      BACK_TO_BACK: '一主一分'
    },
    // 海运出口常量
    seaExportConstants: {
      CONTRACT_STATE_NO: '未签约',
      CONTRACT_STATE_OUT_OF_DATE: '合约失效',
      CONTRACT_STATE_SIGNED: '已签约'
    },
    templateRuleName: {
      CUSTOMER_CN_NAME: '客户中文名',
      CUSTOMER_SHORT_NAME: '客户简称',
      SETTLEMENT_CN_NAME: '结算对象中文名',
      SETTLEMENT_SHORT_NAME: '结算对象简称',
      BOOKING_AGENT_CN_NAME: '订舱代理中文',
      BOOKING_AGENT_SHORT_NAME: '订舱代理简称',
      LOB_NO: '业务编号',
      MBL_NO: 'MBL NO',
      HBL_NO: 'HBL NO',
      REF_NO: '关单号',
      BILL_NO: '账单号',
      BILL_PAYMENT_NO: '付款号',
      WAREHOUSE_NO: '进仓号',
      PONO: '项目编号',
      CUSTOMER_REF_NO: '业务参考号',
      PLATE_NUMBER_DOOR: '车牌号(当前门点)',
      PLATE_NUMBER_DEST: '车牌号(当前目的地)',
      CARRIER_CN_NAME: '船公司中文名',
      CARRIER_SHORT_NAME: '船公司简称',
      ETD: '预计开航日期',
      DESTINATION_PORT_CODE: '目的港',
      DESTINATION_PORT_CODE_CODE: '目的港代码'
    },
    genDocCondition: {
      FormalHbl: '形式分单'
    },
    buttonName: {
      FormalHbl: '形式分单'
    }
  },
  // 枚举参数
  parameter: {
    // 集装箱装载类型
    containerLoadType: {
      FCL: '整箱',
      LCL: '拼箱',
      BB: '委托拼箱',
      BC: 'Buyer Console',
      BULK: '散杂货',
      SPA: '特种箱'
    },
    // 合作伙伴服务项目
    partnerServiceItem: {
      ALL: '全部',
      CUSTOMER: '客户',
      BOOKING_AGENT: '订舱代理',
      OVERSEA_AGENT: '目的港代理',
      DESIGNATION_AGENT: '指定货代理',
      LOCAL: '本地代理',
      SETTLEMENT_AGENT: '结算代理',
      SEA_CMP: '船公司',
      AIR_CMP: '航空公司',
      SEA_CMP_AGENT: '船代',
      CUSTOMS_BROKER: '报关行',
      TRUCK_CMP: '卡车公司',
      WAREHOUSE: '仓库',
      GLOBAL: '集团公司',
      SHIPPER: '发货人',
      CONSIGNEE: '收货人',
      NOTIFY: '通知人',
      PORT_AGENT: '口岸代理',
      FORWARDING_AGENT: '发运代理',
      LOADINGPLACE_COMPANY: '装货地公司',
      SIGNBILLPLACE_COMPANY: '签单地公司',
      DISCHARGEPORT_COMPANY: '卸货港公司',
      DESTINATIONPORT_COMPANY: '目的港公司',
      OTHER: '其他'
    },
    // 角色类型
    roleType: {
      SALES_TYPE: '销售',
      CSR_TYPE: '客服',
      DOC_TYPE: '单证',
      OVERSEAOP_TYPE: '海外客服',
      SALES_OF_GOODS: '揽货销售'
    }
  },
  advanceSearchForm: { // 高级查询组件
    ...zhCN,
    advSearchBtn: '高级查询',
    quickSearch: '快捷检索',
    more: '更多条件',
    Equal: '等于',
    Unequal: '不等于',
    Greater: '大于',
    Less: '小于',
    Like: '包含',
    Not_Like: '不包含',
    Batch: '批量',
    BatchExclude: '批量排除',
    Regexp: '批量模糊',
    In: '包含',
    Range: '范围',
    Not_In: '不包含',
    Is_Not_Null: '不为空',
    Is_Null: '为空',
    Is_It_Empty: '是否为空',
    Date_Item: '快捷项',
    customer: { // 客商
      level: '客商级别',
      chineseName: '中文名',
      status: '客商状态'
    },
    bookingNew: { // 海运订舱极速版
      destinationCountry: '目的港国家',
      hblCheckingStatus: 'HBL 对单状态',
      hblBlType: 'HBL 提单方式',
      hblBillOfLadingNumber: 'HBL 提单流水号',
      hblReleasingStatus: 'HBL 放单状态',
      hblBlType2: 'HBL 提单类型',
      mblCheckingStatus: 'MBL 对单状态',
      mblBlType: 'MBL 提单方式',
      mblBillOfLadingNumber: 'MBL 提单流水号',
      overseaCustomerService: '海外客服',
      customerLevel: '客户级别',
      isSignContract: '是否签约',
      userDefinedField1: '自定义字段1',
      userDefinedField2: '自定义字段2',
      userDefinedField3: '自定义字段3',
      opOffice: '操作分公司',
      salesOffice: '销售分公司',
      bookingAgentIsNull: '订舱代理为空'
    },
    shortcut: '快捷选项',
    daterange: '范围',
    lt: '小于',
    gt: '大于',
    eq: '等于',
    notEq: '不等于',
    like: '包含',
    draft: '草稿',
    commit: '提交',
    check: '审核',
    createDate: '创建日期',
    nowWeek: '本周',
    preWeek: '上周',
    nextWeek: '下周',
    nowMonth: '本月',
    preMonth: '上月',
    nextMonth: '下月',
    doubleClickToSelect: '双击文本框选择节点状态查询',
    fitAll: '满足以下全部',
    fitAny: '满足以下任意'
  },
  route: {
    dashboard: '首页',
    baseInfo: '基础资料',
    seaport: '海港',
    airport: '空港',
    airlineCode: '航空公司代码',
    operationRequirementDescribe: '操作要求描述',
    city: '城市',
    basicData: '基础数据',
    customsCommodityCode: '海关商品编码',
    usCommodityCode: '美国商品编码',
    country: '国家',
    rateManagement: '汇率管理',
    chargeService: '收费项目',
    costPlan: '费用方案',
    guarantee: '保函',
    payService: '收费项目',
    partner: '合作伙伴',
    mailingAddress: '收发通地址',
    seaPortRequirement: '港口要求（海港）',
    airPortRequirement: '港口要求（空港）',
    partnerInformationImport: '合作伙伴信息导入',
    seaExport: '海运出口',
    bookingNew: '海运订舱极速版',
    ProjectManage: '项目管理',
    project: '项目',
    order: '订单管理',
    warehousing: '进仓管理',
    inventory: '库存管理',
    seaImport: '海运进口',
    airExport: '空运出口',
    seaImportBooking: '海运操作',
    airExportBooking: '空运订舱',
    airImportBooking: '空运操作',
    railwayExport: '铁路出口',
    integratedJob: '综合物流',
    remoteBooking: '远程订舱',
    prediction: '预报',
    preBooking: '订舱预审',
    preOrder: '订单预审'
  },
  navbar: {
    screenfull: '全屏',
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码'
  },
  act: {
    billing: {
      pleaseSelectBilling: '请选择账单！',
      hasConfirmed: '【{0}】账单已确认！',
      hasReviewed: '【{0}】账单已复核！',
      hasBillingGroup: '【{0}】账单已做过对账单！',
      hasInvoice: '【{0}】账单已开票！',
      hasWriteOff: '【{0}】账单已核销！',
      confirmDelete: '确定删除这{0}条账单吗？',
      noConfirmBill: '没有可确认的账单！',
      noRecheckBill: '没有可复核的账单！',
      noCancelRecheckBill: '没有可取消确认的账单！',
      batchConfirmBill: '确定要批量确认这{0}个账单吗？',
      batchRecheckBill: '确定要批量复核这{0}个账单吗？',
      noCancelConfirmBill: '没有可取消确认的账单！',
      confirmCancelBill: '确定要取消确认这{0}个账单吗？',
      cancelRecheckBill: '确定要取消复核这{0}个账单吗？',
      sameSettlementAgent: '账单的结算代理必须相同！',
      hasBillingGroupNo: '已经创建过对账单号',
      noBillToBillingGroup: '没有账单可做对账单',
      confirmSuccess: '确认成功！',
      recheckSuccess: '复核成功！',
      cancelConfirmSuccess: '取消确认成功',
      cancelRecheckSuccess: '取消复核成功！',
      reconciliationAmountNotSupport: '您输入的对账金额不合理！',
      overseaHasPushed: '【{0}】账单已同步,不能删除！',
      advDeleteConfirmTitle: '代收垫付账单已经推送金蝶，删除前请确保金蝶已删除对应单据'
    },
    billingGroup: {
      hasConfirmed: '【{0}】对账单已确认！',
      hasReviewed: '【{0}】对账单已复核！',
      confirmDelete: '确定删除这{0}条对账单吗？',
      billingNotNull: '账单不能为空！',
      canNotRemoveAllBills: '不能移除全部账单！',
      settlementAgentNotNull: '账单【{0}】的结算代理不能为空！',
      settlementAgentAndAccountCanNotSame: '账单【{0}】的结算代理与对账单的结算对象不一致，请移除该账单再进行保存！',
      validateAp: '收支类型为应收时,应收账单总金额不能小于应付账单总金额！',
      validateAr: '收支类型为应付时,应付账单总金额不能小于应收账单总金额！',
      selectedBillingGroup: '请选择对账单！',
      batchConfirmBillGroup: '确定要批量确认这{0}条对账单吗？',
      batchConfirmBill: '账单状态是否刷新为已确认？',
      noRecheckBillGroup: '没有可复核的对账单！',
      batchRecheckBillGroup: '确定要复核这{0}个对账单吗？',
      batchCancelRecheckBillGroup: '确定要取消复核这{0}个对账单吗？',
      noCancelRecheckBillGroup: '没有可取消复核的对账单！',
      noCancelConfirmBillGroup: '对账单已复核，不能取消确认！'
    }
  },
  grid: {
    resetSort: '重置排序',
    restColumns: '重置列',
    autoSizeColumns: '自动调整所有列',
    pinLeftAll: '锁定左侧所有列',
    subtotal: '小计',
    groupedSubtotal: '分项计数',
    summaryMode: '统计汇总方式',
    count: '计数',
    sum: '求和'
  }
}

// agGrid表格
export const i18n_ag_grid = {
  // for filter panel
  page: '页',
  more: '更多',
  to: '-',
  of: '至',
  next: '下一页',
  last: '上一页',
  first: '第一页',
  previous: 'previous',
  loadingOoo: '加载...',

  // for set filter
  selectAll: '全选',
  searchOoo: '搜索...',
  blanks: '空白',

  // for number filter and text filter
  filterOoo: '过滤...',
  applyFilter: '应用过滤...',

  // for number filter
  equals: '等于',
  lessThan: '小于',
  greaterThan: '大于',

  // for text filter
  contains: '包含',
  startsWith: '从开始',
  endsWith: '结束',

  // the header of the default group column
  group: '数据分组',

  // tool panel
  columns: '设置列',
  filters: '过滤器',
  rowGroupColumns: '行群列',
  rowGroupColumnsEmptyMessage: '拖动列名至此处可以对数据分组(当前页)',
  valueColumns: '值列',
  pivotMode: '枢轴模式',
  groups: '数据分组',
  values: '值',
  pivots: '枢轴',
  valueColumnsEmptyMessage: '值列空消息',
  pivotColumnsEmptyMessage: '枢轴列空消息',
  toolPanelButton: '工具面板按钮',

  // other
  noRowsToShow: '无查询结果',

  // enterprise menu
  pinColumn: '锁定列',
  valueAggregation: '值聚集',
  autosizeThiscolumn: '自动调整列',
  autosizeAllColumns: '自动调整所有列',
  groupBy: '分组',
  ungroupBy: '不分组',
  resetColumns: '重置',
  expandAll: '展开',
  collapseAll: '收缩',
  toolPanel: '工具面板',
  'export': '导出',
  csvExport: 'CSV ',
  excelExport: 'Excel ',

  // enterprise menu pinning
  pinLeft: '锁定 左侧',
  pinRight: '锁定 右侧',
  noPin: '不锁定 <>',

  // enterprise menu aggregation and status panel
  sum: '和',
  min: '最小',
  max: '最大',
  none: '没有',
  count: '计数',
  average: '平均值',

  // standard menu
  copy: '复制',
  copyWithHeaders: '复制包含表头',
  ctrlC: 'ctrl + C',
  paste: '粘贴',
  ctrlV: 'ctrl + V',

  // Set Filter
  selectAllSearchResults: '(选择所有搜索结果)',
  noMatches: '没有匹配的结果',

  // Number Filter & Text Filter
  notEqual: '不等于',
  empty: '请选择',

  // Number Filter
  lessThanOrEqual: '小于或者等于',
  greaterThanOrEqual: '大于或者等于',
  inRange: '范围',
  inRangeStart: '到',
  inRangeEnd: '从',

  // Text Filter
  notContains: '不包含',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: '与',
  orCondition: '或',

  // Filter Buttons
  resetFilter: '重置',
  clearFilter: '清除',
  cancelFilter: '取消',

  // Filter Titles
  textFilter: '文本筛选器',
  numberFilter: '数字筛选器',
  dateFilter: '日期筛选器',
  setFilter: '集合筛选器',

  // Other
  enabled: '激活',
  // Enterprise Menu Aggregation and Status Bar
  avg: '平均',
  filteredRows: '已过滤的',
  selectedRows: '已选择的',
  totalRows: '总行数',
  totalAndFilteredRows: '行数',
  nextPage: '下一页',
  lastPage: '最后一页',
  firstPage: '第一页',
  previousPage: '前一页',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: '透视图和透视模式',
  pivotChart: '透视图',
  chartRange: '图表范围',

  columnChart: '柱形图',
  groupedColumn: '已分组',
  stackedColumn: '已堆积',
  normalizedColumn: '100% 已堆积',

  barChart: '条形图',
  groupedBar: '已分组',
  stackedBar: '已堆积',
  normalizedBar: '100% 已堆积',

  pieChart: '饼图',
  pie: '饼',
  doughnut: '图环图',

  line: 'Line',

  xyChart: 'X Y (散点图)',
  scatter: '散点',
  bubble: '气泡',

  areaChart: '面积图',
  area: '面积',
  stackedArea: '已堆积',
  normalizedArea: '100% 已堆积',

  histogramChart: '直方图',

  // Charts
  pivotChartTitle: '数据透视图',
  rangeChartTitle: '范围图',
  settings: '设置',
  data: '数据',
  format: '格式',
  categories: '类别',
  defaultCategory: '(无)',
  series: '系列',
  xyValues: 'X Y 值',
  paired: '配对模式',
  axis: '轴',
  navigator: '导览器',
  color: '颜色',
  thickness: '厚度',
  xType: 'X 类型',
  automatic: '自动',
  category: '类别',
  number: '数字',
  time: '时间',
  xRotation: 'X 旋转',
  yRotation: 'Y 旋转',
  ticks: '刻度',
  width: '宽度',
  height: '高度',
  length: '长度',
  padding: '填充',
  spacing: '间距',
  chart: '图标',
  title: '标题',
  titlePlaceholder: '图表标题-双击可编辑',
  background: '背景',
  font: '字体',
  top: '顶部',
  right: '右',
  bottom: '底部',
  left: '左',
  labels: '标签',
  size: '大小',
  minSize: '最小尺寸',
  maxSize: '最大尺寸',
  legend: '说明',
  position: '位置',
  markerSize: '标记大小',
  markerStroke: '标记笔划',
  markerPadding: '标记填充',
  itemSpacing: '字段间距',
  itemPaddingX: '字段填充 X',
  itemPaddingY: '字段填充 Y',
  layoutHorizontalSpacing: '水平间距',
  layoutVerticalSpacing: '垂直间距',
  strokeWidth: '笔划宽度',
  offset: '偏移',
  offsets: '偏移量',
  tooltips: '提示',
  callout: '标注',
  markers: '标记',
  shadow: '阴影',
  blur: '模糊',
  xOffset: 'X 偏移',
  yOffset: 'Y 偏移',
  lineWidth: '线宽',
  normal: '正常',
  bold: '粗体',
  italic: '斜体',
  boldItalic: '粗斜体',
  predefined: '预定义',
  fillOpacity: '填充不透明度',
  strokeOpacity: '线条不透明度',
  histogramBinCount: 'Bin数量',
  columnGroup: '柱形图',
  barGroup: '条形图',
  pieGroup: '饼图',
  lineGroup: '线图',
  scatterGroup: 'X Y (散点图)',
  areaGroup: '面积图',
  histogramGroup: '直方图',
  groupedColumnTooltip: '已分组',
  stackedColumnTooltip: '已堆积',
  normalizedColumnTooltip: '100% 已堆积',
  groupedBarTooltip: '已分组',
  stackedBarTooltip: '已堆积',
  normalizedBarTooltip: '100% 已堆积',
  pieTooltip: '饼图',
  doughnutTooltip: '环形图',
  lineTooltip: '线图',
  groupedAreaTooltip: '已分组',
  stackedAreaTooltip: '已堆积',
  normalizedAreaTooltip: '100% 已堆积',
  scatterTooltip: '散点图',
  bubbleTooltip: '气泡图',
  histogramTooltip: '直方图',
  noDataToChart: '没有可供绘制的数据。',
  pivotChartRequiresPivotMode: '数据透视图需要确保数据透视模式已启用。',
  chartSettingsToolbarTooltip: '菜单',
  chartLinkToolbarTooltip: '链接到图表',
  chartUnlinkToolbarTooltip: '取消与图表的链接',
  chartDownloadToolbarTooltip: '下载图表',

  // ARIA
  ariaHidden: '隐藏',
  ariaVisible: '可见',
  ariaChecked: '选中',
  ariaUnchecked: '未选中',
  ariaIndeterminate: '不确定',
  ariaColumnSelectAll: '切换选择所有列',
  ariaInputEditor: '输入编辑器',
  ariaDateFilterInput: '按日期筛选',
  ariaFilterInput: '输入筛选',
  ariaFilterColumnsInput: '筛选列输入',
  ariaFilterValue: '筛选值',
  ariaFilterFromValue: '-从-值中筛选',
  ariaFilterToValue: '-到-值中筛选',
  ariaFilteringOperator: '筛选运算符',
  ariaColumnToggleVisibility: '切换列可见性',
  ariaColumnGroupToggleVisibility: '切换列分组可见性',
  ariaRowSelect: '按空格键选择此行',
  ariaRowDeselect: '按空格键取消选择此行',
  ariaRowToggleSelection: '按空格键切换行选择',
  ariaRowSelectAll: '按空格键切换所有行选择',
  ariaSearch: '搜索',
  ariaSearchFilterValues: '搜索筛选值'
}
